// 接口管理
import axios from "axios";

// 接口basicUrl设定
var basicUrl = "https://test-api.wanos.vip:8125/";

// axios公共方法
var publicAxios = function (message, api_c2g, operatype, callback) {
  let serverUrl = basicUrl + api_c2g;

  axios.interceptors.request.use(
    (config) => {
      if (localStorage.getItem("token")) {
        config.headers.token = localStorage.getItem("token");
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  if (operatype == "get") {
    axios
      .get(serverUrl, message)
      .then(function (res) {
        callback(res);
      })
      .catch(function (error) {
        console.log(error);
      });
  } else if (operatype == "put") {
    axios
      .put(serverUrl, message)
      .then(function (res) {
        callback(res);
      })
      .catch(function (error) {
        console.log(error);
      });
  } else if (operatype == "post") {
    axios
      .post(serverUrl, message)
      .then(function (res) {
        callback(res);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
};

// 留资
var holdcall = function (name, mobile, company, callback) {
  let message_info = {};
  message_info.name = name;
  message_info.mobile = mobile;
  message_info.company = company;

  message_info.create_time = 0;
  message_info.id = 0;
  message_info.update_time = 0;

  publicAxios(message_info, "index/holdcall", "post", function (info) {
    callback(info.data);
  });
};

export { holdcall };
